import React, {useState} from 'react';
import Well from "components/Well";
import Button from "components/Button";
import {PlusIcon, TrashIcon} from "@heroicons/react/solid";
import {FieldArray, FieldArrayRenderProps} from "formik";
import {InformationAPIData} from "../../../types/Information";
import {TextAreaField, TextField} from "../Form";

type Props = {
  name: string
  information?: Array<InformationAPIData>
}

function InformationListField({name, information}: Props) {
  const [lastAddedIndex, setLastAddedIndex] = useState<number | null>(null);

  return (
    <FieldArray name={name}>
      {({push, remove, form}: FieldArrayRenderProps) => {

        const sections = name
          .split('.')
          .reduce((object, key) => object[key], form.values) as Array<InformationAPIData> | undefined

        return (
          <>
            <ul>
              {sections?.map((section, index) => (
                // TODO: Make these fold down?
                <li key={index} className="my-4">
                  <Well
                    dark={name.includes('.')}
                    heading={`Section ${index + 1}`}
                    action={
                      <Button
                        color={Button.colors.WHITE}
                        size={Button.sizes.X_SMALL}
                        icon={TrashIcon}
                        onClick={() => {
                          remove(index)
                          setLastAddedIndex(null)
                        }}
                      />
                    }>

                    <div className="grid grid-cols-1 gap-y-6 gap-x-4 lg:grid-cols-6">

                      {/* Title */}
                      <div className="sm:col-span-4 xl:col-span-3">
                        <TextField
                          label="Title *"
                          hint='255 chars max'
                          name={`${name}.${index}.name`}
                          maxLength={255}
                          autoFocus={lastAddedIndex === index}
                        />
                      </div>

                      {/* Content */}
                      <div className="sm:col-span-6">
                        <TextAreaField
                          label="Content *"
                          hint='50,000 chars max'
                          rows={8}
                          name={`${name}.${index}.content`}
                          maxChars={50000}
                        />
                      </div>
                    </div>
                  </Well>
                </li>
              ))}
            </ul>

            <div className={information?.length ? 'mt-4' : ''}>
              <Button
                color={Button.colors.SECONDARY}
                icon={PlusIcon}
                size={Button.sizes.TINY}
                onClick={() => {
                  push({name: '', content: ''})
                  setLastAddedIndex(information?.length ?? 0)
                }}
              >
                Add Section
              </Button>
            </div>
          </>
        )
      }}
    </FieldArray>
  );
}

export default InformationListField;